import Link from "next/link";
import { useEffect, useState } from "react";
import { PartnersListSet } from "../../api/partners";
import * as P from "./Partners-styles";

const Partners = () => {
  const [partnersList, setPartnersList] = useState("");

  const fetchPartners = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await PartnersListSet(body);
    if (res.Code === "0000") {
      setPartnersList(res.Data?.rows);
    } else {
      console.error(res?.Data?.Msg);
    }
  };
  useEffect(() => {
    fetchPartners();
  }, []);

  return (
    <>
      <P.Container>
        <P.TitleWrapper>
          <img src="/assets/imgs/page/partners/main_bg.jpg" alt="" />
          <div>
            <h2>미래의 당연함을</h2>
            <h2>[고객사와 함께]</h2>
            <h2>만들다</h2>
          </div>
        </P.TitleWrapper>
        <P.CommonUnderBar />
        <P.GridWrapper className="container">
          {partnersList !== undefined &&
            partnersList.length > 0 &&
            partnersList.map((el, i) => (
              <P.ImgBox key={i}>
                <img
                  className="default-img"
                  src={el.img_url}
                  alt={el.img_alt}
                />
              </P.ImgBox>
            ))}
        </P.GridWrapper>
      </P.Container>
    </>
  );
};
export default Partners;
